import { useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
// import LogoutContainer from "../Layout/LogoutContainer";
import { HeaderStyle } from "../Common/styles/header";
import { useAppSelector } from "../../Redux/hooks";
import { platformAdminPermissions } from "../../utils/roles";
import StudiesList from "./StudiesList";

const AllStudies = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const platformPermissions = useAppSelector(
    (state) => state.user.platformPermissions
  );

  const canEdit = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.managePlatform),
    [platformPermissions]
  );
  const canCreate = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.createStudy),
    [platformPermissions]
  );

  return (
    <>
      <Box
        sx={{
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        {/* <TextField
          key={searchId}
          placeholder="Search for Study"
          style={{ width: "30%" }}
          defaultValue={searchText}
          onChange={(e) => modifySearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <GridSearchIcon />
              </InputAdornment>
            ),
            endAdornment: searchText && (
              <InputAdornment position="end">
                <IconButton onClick={handleClearSearch}>
                  <CloseRounded />
                </IconButton>
              </InputAdornment>
            ),
          }}
        /> */}
        {/* <Box sx={{ ml: "auto" }}>
          <LogoutContainer />
        </Box> */}
      </Box>
      <Box sx={HeaderStyle}>
        <Typography fontWeight="medium" color="text.primary">
          All Studies
        </Typography>

        {canCreate && (
          <Box sx={{ ml: "auto" }}>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setOpenDrawer(true)}
            >
              New Study
            </Button>
          </Box>
        )}
      </Box>
      <Box sx={{ p: 2.5, height: "calc(100vh - 132px)", overflow: "auto" }}>
        <StudiesList
          // searchText={searchText}
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          canEdit={canEdit}
          type="all-studies"
        />
      </Box>
    </>
  );
};

export default AllStudies;
